module.exports = __webpack_public_path__ + "media/images/voice06-2-d07634301c66e83d3426ac2cdfd64f9e.jpg";